




















import { Component, Emit, Prop, Vue } from "vue-property-decorator";
import Heart from "./Heart.vue";

@Component({
  components: { Heart },
})
export default class Card extends Vue {
  @Prop() config?: any;

  iconClicked = false;
  click(icon: boolean) {
    if (icon) {
      this.fav();
      this.iconClicked = true;
    } else {
      if (!this.iconClicked) {
        this.open();
      }
      this.iconClicked = false;
    }
  }
  get date() {
    let start, end;
    if (
      this.config.start_date &&
      new Date(this.config.start_date).getTime() > Date.now()
    ) {
      start = {
        day: new Date(this.config.start_date).getMonth(),
        month: new Date(this.config.start_date).getDay(),
        year: new Date(this.config.start_date).getFullYear(),
      };
    }
    if (this.config.end_date) {
      end = {
        day: new Date(this.config.end_date).getMonth(),
        month: new Date(this.config.end_date).getDay(),
        year: new Date(this.config.end_date).getFullYear(),
      };
    }
    const formatter = (date: any) =>
      (date.day < 10 ? "0" + date.day : date.day) +
      "." +
      (date.month < 10 ? "0" + date.month : date.month);
    if (start && end) {
      if (start.year == end.year) {
        return formatter(start) + " - " + formatter(end);
      }
      return formatter(start) + start.year + " - " + formatter(end) + end.year;
    } else if (!start && end) {
      return "bis zum " + formatter(end) + "." + end.year;
    } else if (start && !end) {
      return "ab dem " + formatter(start) + "." + start.year;
    }
    return null;
  }
  @Emit("open")
  open() {
    return;
  }
  @Emit("fav")
  fav(): { id: number; activ: boolean } {
    this.config.isFavorite = !this.config.isFavorite;
    return { id: this.config.id, activ: this.config.isFavorite };
  }
}
